export default "__VITE_ASSET__de659a8c__"